import { render, staticRenderFns } from "./IcoSkillsDomainPeople.vue?vue&type=template&id=011dfe69"
import script from "./IcoSkillsDomainPeople.vue?vue&type=script&lang=js"
export * from "./IcoSkillsDomainPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports